import angular from 'angular';

import DateComponent from './date.cmpt';

export default angular
    .module('application.component.date', [])
    .component(DateComponent.selector, DateComponent);



// WEBPACK FOOTER //
// ./src/application/component/date/index.js